export default __webpack_public_path__ + "5cb424478813105bf73a6641877d990c.svg";